import React from 'react';
import ComplianceItemDetailSection from '../../../sections/AdminDashboard/ComplianceItems/ComplianceItemDetail';

const ComplianceItemDetail = () => {
  return <ComplianceItemDetailSection />;
};

export default ComplianceItemDetail;
